import Application from "../../Application";
import SystemParameterPresenter, {
  ISystemParameterPresenter
} from "../../presenter/systemparameter/SystemParameterPresenter";
import GetSystemParametersInteractor from "./GetSystemParametersInteractor";

export default class ShowSystemParametersInteractor {
  private application: Application;
  private output?: ISystemParameterPresenter;

  constructor(application) {
    this.application = application;
  }

  async getSystemParameters() {
    const systemParameters = await this.application.container
      .resolve<GetSystemParametersInteractor>("getSystemParameters")
      .execute();
    return systemParameters;
  }

  execute() {
    this.output = SystemParameterPresenter({
      application: this.application,
      initialState: {
        systemParameters: []
      }
    });

    this.getSystemParameters().then(
      systemParameters =>
        this.output && this.output.setSystemParameters(systemParameters)
    );

    return this.output;
  }
}
